import { isRouteErrorResponse } from "react-router"
import { isRedirect } from "source/shared/routingUtils"
import { isModuleImportTypeError } from "source/CommonErrorBoundary"
import {
  apiErrorCode,
  isCommonErrorStatus,
} from "source/shared/utils/errorResponses"

export function isIgnoredRouteError(error: unknown): boolean {
  if (isRedirect(error)) return true

  const code = isRouteErrorResponse(error)
    ? error.status.toString()
    : apiErrorCode(error)
  if (isCommonErrorStatus(code)) return true

  return isModuleImportTypeError(error)
}
